module.exports = __webpack_public_path__ + "img/move-sign.cf053d21.svg";